<template>
    <modal :title="$t(title)" :visible.sync="dialogVisible" v-bind="formAttrs" destroy-on-close>
        <el-form :model="model" style="padding:15px">
            <el-form-item>
                <el-col :span="formItem.span || 24" v-for="formItem in form" :key="formItem.index">
                    <el-form-item :label="formItem.title" :rules="formItem.rules" :prop="formItem.index"
                        :labelWidth="formItem.labelWidth || '150px'"
                        v-if="formItem.hidden ? !formItem.hidden($store.getters.userInfo.scope) : true"
                        :required="formItem.required">
                        <!-- 组件形式则渲染组件 -->
                        <template v-if="formItem.component">
                            <component :is="formItem.component" :model="model" :index="formItem.index" :form="formItem">
                            </component>
                        </template>
                        <template v-else-if="mode === 'edit'">
                            <!-- input -->
                            <template v-if="formItem.type === 'input'">
                                <el-input v-model="model[formItem.index]"></el-input>
                            </template>

                            <!-- 类型为select时 selectOption需是一个Objec对象 未经测试 后期可能会有所改动 -->
                            <template v-else-if="formItem.type === 'select'">
                                <el-select v-model="model[formItem.index]">
                                    <el-option :label="opt.title" :value="key" v-for="(opt, key) in formItem.selectOption"
                                        :key="key"></el-option>
                                </el-select>
                            </template>

                            <!-- 不可修改类型 -->
                            <template v-else-if="formItem.type === 'text'">
                                <TextType :model="model" :formItem="formItem"></TextType>
                            </template>
                        </template>
                        <!-- mode为view时的数据处理 -->
                        <template v-else>
                            <TextType :model="model" :formItem="formItem"></TextType>
                        </template>
                    </el-form-item>
                </el-col>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <span v-for="(btn, index) in buttons" :key="index">
                <!-- 取消按钮 -->
                <template v-if="btn === 'cancel'">
                    <el-button type="primary" @click="close">{{ $t('public.cancel') }}</el-button>
                </template>

                <!-- 确定按钮 -->
                <template v-else-if="btn === 'confirm'">
                    <el-button type="primary" @click="confirm">{{ $t('buttonTitle.Confirm') }}</el-button>
                </template>
            </span>
        </div>
    </modal>
</template>

<script>
import TextType from '@/components/DyForm/templates/TextType';
export default {
    props: {
        title: {
            type: String,
            default: $t('integration.title')
        },
        // 表单绑定的属性
        formAttrs: {
            type: Object,
            default: () => {
                return {
                    inline: false,
                    width: '800px'
                };
            }
        },
        // 表单结构
        form: {
            type: Array
        },
        // 表单对应的值
        value: {
            type: Object
        },
        mode: {
            type: String, // 可选edit 和 view 分别代表编辑模式和查看模式,
            default: 'edit'
        },
        // 在用户点击确定后执行回调 会将表单的数据导出 该函数如果定义则必须返回一个Promise 如果Promise内的值为false 则对话框不会关闭 通常如果手动校验值校验失败让其返回false
        callback: {
            type: Function
        },
        // 控制按钮组的显示
        buttons: {
            type: Array,
            // 取消按钮,确定按钮
            default: () => ['cancel', 'confirm']
        }
    },
    components: {
        TextType
    },
    data: function () {
        return {
            dialogVisible: false,
            model: {}
        };
    },
    watch: {
        form(newval) {
            newval.forEach(formItem => {
                // 说明该表单项依赖于两个后端返回的字段 会在model里添加这两个属性
                if (formItem.index instanceof Array) {
                    formItem.index.forEach(modelKey => {
                        this.$set(this.model, modelKey, undefined);
                    });
                } else {
                    // 单字段处理

                    // 有默认值则赋值
                    if (formItem.default) {
                        this.$set(this.model, formItem.index, formItem.default);
                    } else {
                        this.$set(this.model, formItem.index, undefined);
                    }
                }
            });
            // 至少有一个表单则会自动取消隐藏
            if (newval.length) {
                this.dialogVisible = true;
            }
        },
        value(newval) {
            this.model = newval;

            // Object.keys(this.model).forEach(key => {
            //     this.model[key] = newval[key];
            // });
        }
    },
    methods: {
        close() {
            this.dialogVisible = false;
        },
        confirm() {
            this.callback &&
                this.callback(this.model).then(res => {
                    if (res !== false) {
                        this.close();
                    }
                });
        }
    }
};
</script>

<style scoped lang="scss">
// 二级的表单项不要有margin-bottom
.el-form-item__content>.el-form-item--mini.el-form-item {
    margin-bottom: 0px !important;
}
</style>
